module.exports = __webpack_public_path__ + "assets/img/recordIcon6.1a1a6947.png";